import { companyName, companyShortName } from '../../services/Functions';

const DEFAULT_LOGO_COLOR = '#1b6b38';
const DEFAULT_BRAND_COLOR = '#1b6b38';
const DEFAULT_BRAND_NAVY = '#0c2356';
const DEFAULT_LOGO_COLOR_LIGHT = '#c8e6d0';

const lightenHex = (hex, mixRatio = 0.92) => {
  const normalized = String(hex || '').replace('#', '');
  if (!/^[0-9a-fA-F]{6}$/.test(normalized)) return DEFAULT_LOGO_COLOR_LIGHT;

  const channels = [0, 2, 4].map((start) => parseInt(normalized.slice(start, start + 2), 16));
  const lighten = (channel) => Math.round(channel + (255 - channel) * mixRatio);
  const toHex = (value) => value.toString(16).padStart(2, '0');

  return `#${toHex(lighten(channels[0]))}${toHex(lighten(channels[1]))}${toHex(lighten(channels[2]))}`;
};

export const getLogoColorLight = (logoColor) => lightenHex(logoColor || DEFAULT_LOGO_COLOR);

export const DISCO_META = {
  '11': {
    gstNo: '04-07-2716-001-73',
    website: 'www.lesco.com.pk',
    logoColor: '#e31e24',
    brandColor: '#1b6b38',
    brandNavy: '#00aeef',
  },
  '12': {
    gstNo: '25-00-2716-002-82',
    website: 'www.gepco.com.pk',
    logoColor: '#2e7d32',
    brandColor: '#1b6b38',
    brandNavy: '#1565c0',
  },
  '13': {
    gstNo: '04-07-2716-003-71',
    website: 'www.fesco.com.pk',
    logoColor: '#1565c0',
    brandColor: '#1b6b38',
    brandNavy: '#0d47a1',
  },
  '14': {
    gstNo: '04-07-2716-004-70',
    website: 'www.iesco.com.pk',
    logoColor: '#0080cc',
    brandColor: '#1b6b38',
    brandNavy: '#0066b3',
  },
  '15': {
    gstNo: '04-07-2716-007-55',
    website: 'www.mepco.com.pk',
    logoColor: '#c62828',
    brandColor: '#1b6b38',
    brandNavy: '#0c2356',
  },
  '26': {
    gstNo: '04-07-2716-008-54',
    website: 'www.pesco.gov.pk',
    logoColor: '#2e7d32',
    brandColor: '#1b6b38',
    brandNavy: '#1a237e',
  },
  '27': {
    gstNo: '04-07-2716-009-53',
    website: 'www.hazeco.com.pk',
    logoColor: '#388e3c',
    brandColor: '#1b6b38',
    brandNavy: '#0c2356',
  },
  '37': {
    gstNo: '04-07-2716-005-69',
    website: 'www.hesco.gov.pk',
    logoColor: '#2e7d32',
    brandColor: '#1b6b38',
    brandNavy: '#0c2356',
  },
  '38': {
    gstNo: '04-07-2716-010-52',
    website: 'www.sepco.com.pk',
    logoColor: '#1b6b38',
    brandColor: '#1b6b38',
    brandNavy: '#0c2356',
  },
  '48': {
    gstNo: '04-07-2716-011-51',
    website: 'www.qesco.com.pk',
    logoColor: '#1b6b38',
    brandColor: '#1b6b38',
    brandNavy: '#0c2356',
  },
  '59': {
    gstNo: '04-07-2716-012-50',
    website: 'www.tesco.gov.pk',
    logoColor: '#1b6b38',
    brandColor: '#1b6b38',
    brandNavy: '#0c2356',
  },
};

export const getDiscoCodeFromReference = (referenceNo) => {
  const clean = String(referenceNo || '').replace(/\s/g, '');
  if (!clean) return null;
  if (clean.length === 14) return clean.slice(2, 4);
  if (clean.length >= 4) return clean.slice(2, 4);
  return clean.slice(0, 2);
};

export const getDiscoBillBranding = (referenceNo, fallbackDiscoCode = '15') => {
  const discoCode = getDiscoCodeFromReference(referenceNo) || fallbackDiscoCode;
  const meta = DISCO_META[discoCode] || {
    gstNo: '-',
    website: '-',
    logoColor: DEFAULT_LOGO_COLOR,
    brandColor: DEFAULT_BRAND_COLOR,
    brandNavy: DEFAULT_BRAND_NAVY,
  };
  const shortName = companyShortName(discoCode);

  return {
    discoCode,
    companyTitle: companyName(discoCode).toUpperCase(),
    companyShortName: shortName,
    gstNo: meta.gstNo,
    gstLabel: `${shortName} GST NO: ${meta.gstNo}`,
    website: meta.website,
    logoColor: meta.logoColor || DEFAULT_LOGO_COLOR,
    logoColorLight: getLogoColorLight(meta.logoColor || DEFAULT_LOGO_COLOR),
    brandColor: meta.brandColor || DEFAULT_BRAND_COLOR,
    brandNavy: meta.brandNavy || DEFAULT_BRAND_NAVY,
  };
};
